import { Div } from '../../../../base/components/native/div'
import { FAQItem } from './faq-item'
import { FAQItems } from './faq-items'

export const FAQs = () => {

    
    const base = Div()
    const title = Div('Frequently Asked Questions')
    const items = FAQItems()
    base.append(title, items)

    title.cssClass({
        fontFamily: 'Syne',
        fontSize: '36px',
        fontWeight: '700',
        marginBottom: '56px',
    })
    base.cssClass({
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        marginTop: '0',
        paddingTop: '120px',
        paddingBottom: '60px',
        backgroundColor: '#fff',
        width: '100%',
        textAlign: 'center',
        color: '#000',
        '@media (max-width: 768px)': {
            // marginTop: '30px',
        }
    })

    return base
}